import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import ContentEditable from 'react-contenteditable';
import cn from 'classnames';
import Button from 'components/Form/Button';
import Pencil from 'svg/pencil.svg';
import { useCustomRanges } from 'modules/PatientResults/hooks';
import styles from '../GlucoseConcentrationTrend.pcss';
const CustomLabel = ({ idx, isReadOnly, updatePhiSet })=>{
    const labelRef = useRef(null);
    const [labelText, setLabelText] = useState('');
    const customRanges = useCustomRanges();
    const getPersistedLabelText = ()=>customRanges[idx] && customRanges[idx][2] ? customRanges[idx][2] : '';
    useEffect(()=>{
        setLabelText(getPersistedLabelText());
    }, [
        customRanges
    ]);
    if (isReadOnly) {
        if (labelText) {
            return /*#__PURE__*/ _jsx("div", {
                className: `${styles.customRange__label__textLine} mt-1`,
                children: labelText
            });
        }
        return null;
    }
    const onBlur = (evt)=>{
        const newLabelText = evt.target.innerHTML;
        if (newLabelText !== labelText) {
            const updatedCustomRanges = [
                ...customRanges
            ];
            updatedCustomRanges[idx] = [
                customRanges[idx][0],
                customRanges[idx][1],
                newLabelText
            ];
            updatePhiSet({
                customRanges: updatedCustomRanges
            });
        }
    };
    const onKeyDown = (evt)=>{
        if (evt.code === 'Escape') {
            labelRef.current.innerText = getPersistedLabelText();
            labelRef.current.blur();
            return;
        }
        if ([
            'Enter',
            'NumpadEnter'
        ].includes(evt.code)) {
            labelRef.current.blur();
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: `${styles.customRange__label__textLine} ${styles.customRange__label__customLabel}`,
        children: [
            /*#__PURE__*/ _jsx(ContentEditable, {
                innerRef: labelRef,
                tagName: "span",
                html: labelText,
                className: styles.customRange__label__contentEditable,
                disabled: isReadOnly,
                onBlur: onBlur,
                onChange: null,
                onKeyDown: onKeyDown
            }),
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: "transparent",
                className: cn(styles.customRange__label__action, styles.customRange__label__edit, {
                    'd-none': labelRef && document.activeElement === labelRef.current
                }),
                onClick: ()=>labelRef.current.focus(),
                children: /*#__PURE__*/ _jsx(Pencil, {
                    className: styles.customRange__label__icon
                })
            })
        ]
    });
};
export default CustomLabel;
